import { A, AnchorProps } from './A';

export const ExternalLink = (props: AnchorProps): React.ReactElement<any, any> | null => {
    return <A {...props} icon="box-arrow-up-right" />;
};
